import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { useLogout } from '../../hooks';

export const LogoutLink: React.FC = () => {
	const logout = useLogout();

	return (
		<a
			onClick={ logout }>{ COPY_SPECIFIC.LOGOUT }
		</a>
	);
};
